module.exports = __webpack_public_path__ + "img/trazado5sm.4e9e1a55.webp";